export const valores = [
  {
    nombre: "Respeto",
    actitudes: [
      "Respeta la propiedad ajena",
      "Respeta las diferencias",
      "Respeta a los docentes y compañeros",
    ],
  },
  {
    nombre: "Honradez",
    actitudes: [
      "Cuida el patrimonio institucional y su ambiente",
      "Devuelve oportunamente los objetos",
    ],
  },
  {
    nombre: "Responsabilidad",
    actitudes: [
      "Llega a la hora indicada a la I.E.",
      "Permanece en el aula en el horario establecido.",
      "Asume con responsabilidad las actividades de Educación ambiental.",
    ],
  },
  {
    nombre: "Solidaridad",
    actitudes: [
      "Ayuda a sus compañeros",
      "Colabora en la disciplina y la limpieza del aula y la I.E.",
    ],
  },
  {
    nombre: "Justicia",
    actitudes: [
      "Cumple con las normas de convivencia",
      "Demuestra equidad en la solución de problemas personales y de entorno.",
    ],
  },
  {
    nombre: "Conservación",
    actitudes: [
      "Colabora con la limpieza en el aula y en la I.E.",
      "Colabora con el cuidado de las áreas verdes.",
      "Practica cultura ambiental.",
    ],
  },
  {
    nombre: "Empatía",
    actitudes: [
      "Apoya a sus compañeros cuando lo requiera",
      "Se muestra respetuoso con los adultos mayores",
    ],
  },
];